import React, { useEffect } from "react";
import { PrivateRoutesProps } from "./type";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../../store/store";
import { Box } from "@chakra-ui/react";

const PrivateRoutes: React.FC<PrivateRoutesProps> = ({ Component }) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.user);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/auth", { state: { from: location.pathname }, replace: true });
    }
  }, [isAuthenticated, location.pathname, navigate]);

  if (!isAuthenticated) return null;

  // console.log("PrivateRoutes Component:", Component);
  return (
    <Box
    // fontFamily="body"
    >
      <Component />
    </Box>
  );
};

export default PrivateRoutes;

// const PrivateRoutes: React.FC<PrivateRoutesProps> = ({ Component }) => {
//   const { isAuthenticated } = useSelector((state: RootState) => state.user);
//   const location = useLocation();

//   if (!isAuthenticated) {
//     // console.log("PrivateRoutes Component:", Component);
//     return <Navigate to="/auth" state={{ from: location.pathname }} replace />;
//   }

//   // console.log("PrivateRoutes Component:", Component);
//   return (
//     <Box
//     // fontFamily="body"
//     >
//       <Component />
//       <div>PrivateRoutes</div>
//     </Box>
//   );
// };

// export default PrivateRoutes;
